import { getAppValue } from "@/utils/getAppValue";
import { sva } from "@styled-system/css";

const slots = ["badge", "productsHeader"] as const;

const barkioStyles = sva({
  slots,
  base: {
    badge: {
      color: "#FFFFFF"
    },
    productsHeader: {
      fontWeight: 800,
      bg: "primaryTransparent2"
    }
  }
});

const bibinoStyles = sva({
  slots,
  base: {
    badge: {
      color: "#FFFFFF"
    },
    productsHeader: {
      fontWeight: 500,
      bg: "primaryTransparent"
    }
  }
});

const cameritoStyles = sva({
  slots,
  base: {
    badge: {
      color: "altWarning"
    },
    productsHeader: {
      fontWeight: 800,
      bg: "primaryTransparent"
    }
  }
});

const styles = {
  bibino: bibinoStyles,
  barkio: barkioStyles,
  camerito: cameritoStyles
};

export const style = getAppValue<(typeof styles)[keyof typeof styles]>(styles);
